import { calculateDate } from './helperFunctions';

export const presets = [
  {
    label: 'Past 7 days',
    startDate: calculateDate(-8),
    endDate: calculateDate(-1),
  },
  {
    label: 'Past 14 days',
    startDate: calculateDate(-15),
    endDate: calculateDate(-1),
  },
  {
    label: 'Past 30 days',
    startDate: calculateDate(-31),
    endDate: calculateDate(-1),
  },
  {
    label: 'Past 90 days',
    startDate: calculateDate(-91),
    endDate: calculateDate(-1),
  },
];
export const AVAILABLE_ROLES = [
  {
    key: 2,
    name: 'Manager',
    description: 'Full access to team settings.',
  },
  { key: 3, name: 'Viewer', description: 'Only View access' },
];
export const blinkitColumns = {
  product_listing: [
    'Date',
    'Campaign Name',
    'Targeting Type',
    'Targeting Value',
    'Match Type',
    'Most Viewed Position',
    'Pacing Type',
    'CPM',
    'Impressions',
    'Direct ATC',
    'Indirect ATC',
    'Direct Quantities Sold',
    'Indirect Quantities Sold',
    'Direct Sales',
    'Indirect Sales',
    'New Users Acquired',
    'Estimated Budget Consumed',
    'Direct RoAS',
    'Total RoAS',
  ],
  banner_listing: [
    'Date',
    'Campaign Name',
    'Targeting Type',
    'Targeting Value',
    'Match Type',
    'CPM',
    'Impressions',
    'Reach',
    'CTR',
    'Unique Clicks',
    'Budget Consumed',
  ],
  product_recommendation: [
    'Date',
    'Campaign Name',
    'Pacing Type',
    'CPM',
    'Impressions',
    'Direct ATC',
    'Indirect ATC',
    'Direct Quantities Sold',
    'Indirect Quantities Sold',
    'Direct Sales',
    'Indirect Sales',
    'New Users Acquired',
    'Estimated Budget Consumed',
    'Direct RoAS',
    'Total RoAS',
  ],
};

export const AMAZON_ACCOUNT_REGION = {
  'United States': 'NA',
  'Canada ': 'NA',
  Mexico: 'NA',
  Brazil: 'NA',
  'United Kingdom': 'EU',
  France: 'EU',
  Italy: 'EU',
  Spain: 'EU',
  Germany: 'EU',
  Netherlands: 'EU',
  'United Arab Emirates': 'EU',
  Poland: 'EU',
  Turkey: 'EU',
  Egypt: 'EU',
  'Saudi Arabia': 'EU',
  Sweden: 'EU',
  Belgium: 'EU',
  India: 'EU',
  'South Africa': 'EU',
  Japan: 'FE',
  Australia: 'FE',
  Singapore: 'FE',
};

export const ID_VALIDATION_ERROR =
  'Please ensure the ID is a number and minimum 4 digits long.';
